import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=144204db&scoped=true&"
import script from "./CustomerDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetails.vue?vue&type=style&index=0&id=144204db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144204db",
  null
  
)

export default component.exports